<template>
  <DefaultLayout>
    <slot name="background">
      <div class="col-md-12 pe-0">
        <div class="position-relative"
        style="height: 85vh; background-image: url(/img/403-background.svg); background-size: contain; background-repeat: no-repeat;">
        </div>
      </div>
    </slot>
    <div>
      <div class="container position-absolute zindex-5" style="width: 600px; left: 50%; top: 50%; transform: translate(-50%, -50%);">
        <div class="card p-4">
          <div style="padding: 10px 0; float: left; width: 100%;">
            <img src="~resonance-theme/src/assets/img/apps/networks-logo-light.svg" alt="logo" style="float: left; width: 180px; margin-bottom: 20px;" />
          </div>
          <h2 class="mb-3 text-secondary">
            Error 403
          </h2>
          <p class="fw-normal fs-4 text-secondary mb-4 align-left" style="width: 400px;">
            It seems you're not authorized to access this resource.
          </p>
          <button class="btn btn-primary" style="padding: 0.425rem 1.7rem !important; width: fit-content !important;" @click="contactNow">
            {{ $t('contact-support') }}
          </button>
      </div>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default';

export default {
  components: {
    DefaultLayout,
  },
  methods: {
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
  },
};
</script>
